import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';
import { Slash } from 'lucide-react';

import { ChargeStateXrefTable } from './table';

export function ChargeStateXrefs() {
	const id = window.location.pathname.split('/').pop();
	const chargeId = id ? parseInt(id) : NaN;
	const params = new URLSearchParams(window.location.search);
	const chargeName = params.get('chargeName');
	return (
		<>
			<Breadcrumb className="mb-4 pl-4">
				<BreadcrumbList>
					<BreadcrumbItem>
						<BreadcrumbLink href="/fee/charges">Charges</BreadcrumbLink>
					</BreadcrumbItem>
					<BreadcrumbSeparator>
						<Slash />
					</BreadcrumbSeparator>
					<BreadcrumbItem>
						<BreadcrumbPage>State Mappings</BreadcrumbPage>
					</BreadcrumbItem>
				</BreadcrumbList>
			</Breadcrumb>

			<Card className="w-full">
				<CardHeader>
					<span className="flex flex-row justify-between">
						<CardTitle className="mt-2">State Mappings</CardTitle>
					</span>
					<CardDescription>Charge: {chargeName}</CardDescription>
				</CardHeader>
				<CardContent className="space-y-2">
					<ChargeStateXrefTable chargeId={chargeId} />
				</CardContent>
			</Card>
		</>
	);
}
